
































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VueRecaptcha from "vue-recaptcha";
import axios from "axios";
import { API_URL } from "../global";
import csc from "country-state-city";
import { Action, Getter } from "vuex-class";
import { FETCH_COUNTRIES, GET_STATES_BY_COUNTRY } from "../store/actions.names";
import { COUNTRIES, RECAPTCHA_KEY } from "../store/getters.names";
import { Country } from "../store/store.types";
import { CoolSelect } from "vue-cool-select";

const DEFAULT_FORM_DATA = {
  freight_type: "AIR",
  company: "",
  contact_person: "",
  email: "",
  telephone: "",
  zip_code: null,
  user_city: "",
  user_country: "",
  user_state: "",
  user_additional_info: "",
  pick_up_city: "",
  pick_up_state: "",
  pick_up_zip: null,
  pick_up_country: "",
  delivery_city: "",
  delivery_zip: null,
  delivery_country: "",
  delivery_state: "",

  cargo_no: null,
  length: null,
  length_unit: "in",
  width: null,
  width_unit: "in",
  height: null,
  height_unit: "in",
  weight: null,
  weight_unit: "lbs",
  value_of_goods: "",
  commodity: "",
  hts_code: null,
  cargo_additional_info: ""
};

@Component({
  name: "InquiryForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    VueRecaptcha,
    CoolSelect
  }
})
export default class InquiryForm extends Vue {
  isDisplay: boolean = true;
  $refs!: {
    form: InstanceType<typeof ValidationObserver>;
  };
  inquiryForm: any = JSON.parse(JSON.stringify(DEFAULT_FORM_DATA));
  submitted = false;
  submitSuccess = false;

  captchaToken: string | null = null;
  pick_up_country: any = null;
  pick_up_states: any[] = [];
  delivery_country: any = null;
  delivery_states: any[] = [];
  user_country: any = null;
  user_states: any[] = [];

  length_units: Array<string> = ["in", "cm"];
  weight_units: Array<string> = ["lbs", "kg"];
  freight_types: any = [
    { label: "Air Freight", value: "AIR" },
    { label: "Ocean Freight", value: "OCEAN" }
  ];

  @Action(FETCH_COUNTRIES) featchCountries!: any;
  @Action(GET_STATES_BY_COUNTRY) getStateByCountry: any;
  @Getter(COUNTRIES) countries!: Array<Country>;
  @Getter(RECAPTCHA_KEY) recaptchaKey!: string;
  captchaVerify(resp: string) {
    this.captchaToken = resp;
  }

  @Watch("pick_up_country", { deep: true })
  handlePickUpCountryChange(val: any, oldVal: any) {
    if (val != oldVal) {
      if (val == null) {
        return [];
      }
      this.getStateByCountry(val.short_code).then((data: any) => {
        this.pick_up_states = data;
        this.inquiryForm.pick_up_country = val.name;
      });
      this.inquiryForm.pick_up_state = "";
    }
  }

  @Watch("delivery_country", { deep: true })
  handleDeliveryCountryChange(val: any, oldVal: any) {
    if (val != oldVal) {
      if (val == null) {
        return [];
      }
      this.getStateByCountry(val.short_code).then((data: any) => {
        this.delivery_states = data;
        this.inquiryForm.delivery_country = val.name;
      });
      this.inquiryForm.delivery_state = "";
    }
  }

  @Watch("user_country", { deep: true })
  handleUserCountryChange(val: any, oldVal: any) {
    if (val != oldVal) {
      if (val == null) {
        return [];
      }
      this.getStateByCountry(val.short_code).then((data: any) => {
        this.user_states = data;
        this.inquiryForm.user_country = val.name;
      });
      this.inquiryForm.user_state = "";
    }
  }

  created() {
    this.handleView();
  }

  handleView() {
    this.isDisplay = window.innerWidth <= 767;
    window.addEventListener("resize", this.handleView);
  }

  mounted() {
    this.featchCountries();
  }

  onSubmit() {
    this.$refs.form
      .validate()
      .then(success => {
        if (!success || this.captchaToken == null) {
          return;
        }

        axios
          .post(`${API_URL}/inquiry-form/`, {
            ...this.inquiryForm,
            recaptcha: this.captchaToken
          })
          .then(({ data: any }) => {
            this.inquiryForm = JSON.parse(JSON.stringify(DEFAULT_FORM_DATA));
            this.$nextTick(() => {
              this.$refs.form.reset();
              this.submitted = true;
              this.submitSuccess = true;
            });
          })
          .catch((e: any) => {
            console.log(e);
          });

        // Resetting Values

        // Wait until the models are updated in the UI
      })
      .catch((e: any) => {
        console.log(e);
        this.submitted = true;
      });
  }
}
